const appGeneralConfigurationPage = {
  FEATURES: "features",
  CUSTOM: "custom"
};

export default appGeneralConfigurationPage;
